<template>
  <div>
    <v-autocomplete
      v-model="localIds"
      class="chips-spaced"
      label="Vistas"
      :items="vistasOrdenadas"
      item-value="id_vista"
      :item-text="getVistaText"
      dense
      outlined
      multiple
      chips
      deletable-chips
      clearable
      :loading="loadingVistas"
      :disabled="loadingVistas"
      hide-details
    />

    <div class="mt-2 d-flex align-center" style="gap:8px;">
      <v-btn small outlined @click="selectAll" :disabled="loadingVistas || !vistasOrdenadas.length">
        SELECCIONAR TODO
      </v-btn>

      <v-btn small outlined color="error" @click="deselectAll" :disabled="loadingVistas">
        DESELECCIONAR
      </v-btn>

      <v-spacer />

      <v-btn small color="primary" @click="apply" :disabled="loadingVistas">
        APLICAR CAMBIOS
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'IdsVistasEditor',
  data: () => ({
    localIds: [],
    vistas: [],
    loadingVistas: false,
  }),
  computed: {
    ...mapState(['ids_vistas']),

    vistasOrdenadas() {
      const arr = Array.isArray(this.vistas) ? [...this.vistas] : []
      return arr.sort((a, b) => {
        const an = (a.nombre || '').toString().toLowerCase()
        const bn = (b.nombre || '').toString().toLowerCase()
        return an.localeCompare(bn, 'es')
      })
    }
  },
  watch: {
    ids_vistas: {
      immediate: true,
      handler(v) {
        this.localIds = Array.isArray(v) ? [...v] : []
      }
    }
  },
  mounted() {
    this.getVistas()
  },
  methods: {
    // item-text como función
    getVistaText(item) {
      if (!item) return ''
      return `${item.id_vista} - ${item.nombre}`
    },

    getVistas() {
      this.loadingVistas = true
      axios
        .get('/Catalogos/ListarVistas')
        .then(r => { this.vistas = r.data || [] })
        .catch(err => console.log(err))
        .finally(() => { this.loadingVistas = false })
    },

    selectAll() {
      this.localIds = (this.vistasOrdenadas || [])
        .map(x => parseInt(x.id_vista, 10))
        .filter(Number.isInteger)
    },

    deselectAll() {
      this.localIds = []
    },

    apply() {
      const ids_vistas = [...new Set(
        (this.localIds || [])
          .map(x => parseInt(x, 10))
          .filter(Number.isInteger)
      )].sort((a, b) => a - b)

      this.$store.commit('ids_vistas', { ids_vistas })
      localStorage.setItem('ids_vistas', JSON.stringify(ids_vistas))
    }
  }
}
</script>

<style scoped>
::v-deep .chips-spaced .v-select__selections .v-chip {
  margin-right: 10px !important;
  margin-bottom: 10px !important;
}

::v-deep .chips-spaced .v-select__selections .v-chip .v-chip__content {
  padding: 0 12px !important;
}
</style>
